<template>
  <ValidationProvider :name="name" :rules="selectRules" v-slot="{ classes }" slim>
    <select
      :value="value"
      :class="[classes, 'form-control', {'input-bold' : value != null && value != ''}]"
      @input="$emit('input', $event.target.value)"
    >
      <option value="" disabled selected v-if="placeholder">{{ placeholder }}</option>
      <option
        v-for="item in options"
        :disabled="item.value===''?'disabled':false"
        :key="item.value"
        :value="item.value"
      >{{item.label}}</option>
    </select>
  </ValidationProvider>
</template>
<script>
export default {
  data() {
    return {
      allowedOptions: null
    }
  },
  props: ['name', 'rules', 'value', 'options', 'placeholder'],
  created() {
    // console.log(this.selectRules)
  },
  computed: {
    selectRules() {
      if (this.options !== null) {
        let allowedOptions = this.options.filter(option => option.value !== '').map(option => option.value).join(',')
        return this.rules + '|oneOf:' + allowedOptions
      } else {
        return null
      }
    }
  }
}
</script>
